import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Container as LayoutContainer, PageHeader } from '../layout';
import { Button } from '../layout/buttons/Button';
import CanvassesTable from './CanvassesTable';

const Canvasses = () => {
    return (
        <div className="canvasses">
            <LayoutContainer fluid>
                <Row className="align-items-center">
                    <Col>
                        <PageHeader title="Canvasses" subtext="View and manage all your Canvasses"/>
                    </Col>
                    {/* <Col className="d-flex justify-content-end">
                        <Button iconLeft={{ name: 'user_actions/diamond' }} textColor="var(--brand-as-neutral-black-950)" color="var(--brand-as-neutral-black-transparent-05)" text="Button" >
                            <b>Beep.</b> <span>&nbsp;</span> Need any help with your Canvasses?
                        </Button>
                    </Col> */}
                </Row>
                <CanvassesTable />
            </LayoutContainer>
        </div>
    );
};

export default Canvasses;
